const PROOF_LABELS = {
  readback_verified: "Verified by connected service",
  provider_acknowledgement: "Reported by connected service",
};

export function taskNarrationMeta(task = {}) {
  if (task.authority === "server") {
    if (task.status !== "completed")
      return "Requires connected-service confirmation";
    return PROOF_LABELS[task.proof_level] ?? "Connected-service confirmation";
  }
  return task.client_key ? "Agent-reported progress" : null;
}
